import { openBlock as t, createElementBlock as l, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(i, r) {
  return t(), l("svg", o, [...r[0] || (r[0] = [
    e("g", { "clip-path": "url(#a)" }, [
      e("path", {
        fill: "currentColor",
        d: "m7 14 5-5 5 5z"
      })
    ], -1),
    e("defs", null, [
      e("clipPath", { id: "a" }, [
        e("path", {
          fill: "currentColor",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])]);
}
const c = { render: n };
export {
  c as default,
  n as render
};
